import { WriteRequest } from "~/backendApis/foundation/WriteRequest"
import { ReceiveSettableMailType } from "~/backendApis/viewModel/externalNotification"

interface Params {
  receiveSettableMailType: ReceiveSettableMailType
}

export class RejectUserMailNotificationWriteRequest extends WriteRequest<void> {
  private readonly endpoint: string =
    "/external_notification/user/user_mail_notification/reject"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    return this.apiClient.post(this.endpoint, this.params)
  }
}
